import { Button } from "src/components";
import crossIcon from "../../../assets/cross.svg";

const IsDifferentPoRef = ({
  onCloseModal,
  handleConfirm,
  invoicePoRefNo,
  selectedPoRefNo,
}: {
  onCloseModal: () => void;
  handleConfirm: () => void;
  invoicePoRefNo: string;
  selectedPoRefNo: string;
}) => {
  return (
    <div className="flex flex-col gap-y-2 w-[500px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-lg">
      <div className="flex justify-between items-center">
        <p className="text-normal py-1 font-semibold text-[#1B1A1F]">Is Different PO Ref No</p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
        </Button>
      </div>
      {
        <p className="text-sm mb-2 font-normal text-[#666666]">
          PO Ref No in the invoice is <span className="text-[#8051FF]">({invoicePoRefNo})</span> whereas you are trying to map{" "}
          <span className="text-[#8051FF]">({selectedPoRefNo})</span>. Do you still want to continue?
        </p>
      }

      <div className="flex justify-end gap-x-2">
        <Button loaderSize="small" className="text-white bg-[#8051FF] mt-4" onClick={handleConfirm}>
          Proceed
        </Button>
        <Button className="bg-[#f5f5f5]  mt-4" onClick={onCloseModal}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default IsDifferentPoRef;
